<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">月售票走势</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="月份">
            <el-date-picker
              v-model="chooseDate"
              type="month"
              style="width: 60rem"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="echart">
          <div>
            月销售走势同比
            <LineEchart2Ticket :legendData="legendData" :chartData="monthTicketCompare"></LineEchart2Ticket>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import { getYOYTrendByTimes } from '@/api/src/bigData'
import moment from 'moment'
export default {
  name: "TicketMonthTrend",
  controller: "UI",
  action: "TicketMonthTrend",
  data() {
    return {
      chooseDate: new Date(),
      monthTicketCompare: {},
      legendData: [new Date().getFullYear(), new Date().getFullYear()-1],
    };
  },
  mounted: function () {
    this.onSearch();
  },
  methods: {
    getCharts() {
      this.legendData = [this.chooseDate.getFullYear(), this.chooseDate.getFullYear()-1];
      let date = this.formatterDate(this.chooseDate);
      let params = {
        district: this.CNF("app.districtCode"),
        districtCode: this.CNF("app.districtCode"),
        polityType: 3,
        timeType: "day", 
        timeValue: 30,
        startTime: date + '-01',
        endTime: date + '-' + this.getMonthEnd(date)
      }
      //月销售走势同比
      getYOYTrendByTimes(params).then(res => {
        if(res.data){
          let dataList = res.data.dataList || {};
          let Now = dataList[this.legendData[0]];
          let Last = dataList[this.legendData[1]];
          this.monthTicketCompare = {
            days: Now.map(item => { return moment(item.dataTime).format("DD"); }),
            data: Now.map(item => { return item.count }),
            dataLast: Last.map(item => { return item.count })
          }
        }
      });
    },
    formatterDate(val){
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      return year + '-' + month;
    },
    getMonthEnd(date){
      let arr = date.split('-');
      let year = Number.parseInt(arr[0]);
      let month = Number.parseInt(arr[1]);
      switch (month) {
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
          return 31;
        case 4:
        case 6:
        case 9:
        case 11:
          return 30;
        case 2:
          return ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) ? 29 : 28;
        default:
          return 0;
      }
    },
    onSearch(){
      this.getCharts();
    },
    onCancel(){
      this.chooseDate = new Date();
      this.getCharts();
    }
  },
};
</script>

<style scoped lang="scss">
.echart {
  position: relative;
  width: 100%;
  height: 100%;
}
.echart > div{
  width: 60%;
  height: 48%;
  margin: auto;
  color: #2bc5ff;
  font-weight: bold;
  text-align: center;
}
::v-deep .el-input__inner{
  width: 322px;
}
</style>